/**
* Jump Links JS
* -----------------------------------------------------------------------------
*
* All the JS for the Jump Links component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'jump-links',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( 'button#jump-link__mobile-dropdown-trigger' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( target ).slideToggle();
      } );

      $( '.jump-links a' ).on( 'click', function() {
        const linkHash = $( this ).attr( 'href' ).split( '#' )[1];
        if ( linkHash ) {
          const $target = $( '#' + linkHash );
          if ( $target.length ) {
            let offset = $( '.navbar' ).outerHeight();
            offset += $( '.jump-links' ).outerHeight();

            if ( $( '#announcement-banner' ).length ) {
              offset += $( '#announcement-banner' ).outerHeight();
            }

            if ( $( '#wpadminbar' ).length ) {
              offset += $( '#wpadminbar' ).outerHeight();
            }

            const targetTop = $target.offset().top;
            $( 'html, body' ).animate( {
              scrollTop: targetTop - offset,
            }, 250 );
          }
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'jump-links', COMPONENT );
} )( app );
